import { axios } from '../index';

import config from '../config';

const URL = `${config.gatewayApiUrl}`;

export const getQualificationReport = ({
  companyId,
  payload,
}: {
  companyId: string;
  payload: {
    team_ids: string[];
    qualifications: string[];
    match_mode?: string;
    statuses: string[];
    user_ids?: string[] | null;
    job_titles?: string[];
  };
}) => {
  return axios.post(`${URL}/public/v1/reports/companies/${companyId}/qualifications`, payload, {
    headers: {
      accept: 'application/json',
    },
    responseType: 'blob',
  });
};
